import React from 'react';

// A field people never see (moved off screen, skipped by Tab, hidden from
// screen readers). Bots that fill in every field fill this one in too, and the
// server turns them away (backend/botCheck.js).
const offscreen = {
  position: 'absolute',
  left: '-10000px',
  top: 'auto',
  width: 1,
  height: 1,
  overflow: 'hidden',
};

const Honeypot = React.forwardRef(function Honeypot(props, ref) {
  return (
    <div style={offscreen} aria-hidden="true">
      <label>
        Website
        <input ref={ref} type="text" name="website" tabIndex={-1} autoComplete="off" defaultValue="" />
      </label>
    </div>
  );
});

export default Honeypot;
